import { Inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfiguration } from '@app/infrastructure/auth/app-configuration';

const REPLACE_LIST = [
	'/frontend/account/check-permission',
	'/frontend/account/get-accounts',
	'/frontend/account/get-account-tk',
	'/frontend/account/get-my-organizations-light',
	'/frontend/account/get-users',
	'/frontend/account/generate-onboarding-json-preview',
	'/frontend/account/generate-onboarding-json',
	'/frontend/account/get-template-permissions',
	'/frontend/account/get-account-permissions',
	'/frontend/admin/invite-reseller',
	'/frontend/organization/invite',
	'/frontend/organization/rename-account',
	'/frontend/organization/billing-history',
	'/frontend/organization/get-permitted-accounts',
	'/frontend/organization/onboard_checklist',
	'/frontend/organization/not_onboarded_accounts',
	'/frontend/reseller/billing-history',
	'/frontend/reseller/add-organization',
	'/frontend/reseller/get-accounts',
	'/frontend/reseller/generate-links',
	'/frontend/reseller/check-arn',
	'/frontend/reseller/delete-link',
	'/frontend/reseller/get-ou',
	'/frontend/reseller/select-ou',
	'/frontend/account/change_status',
	'/frontend/cv/delete-account',
	'/frontend/cv/update-billing-day-emails',
	'/frontend/cv/get_user_organisations',
	'/frontend/cv/get-cur-dates',
	'/frontend/cv/get-cur-by-date',
	'/frontend/partner/admin/partner-users',
	'/frontend/partner/partner-users',
	'/frontend/partner/invite',
	'/frontend/partner/admin-invite',
	'/frontend/invite-user',
	'/frontend/org-budget',
	'/frontend/describe-organization',
	'/frontend/customer/is_alive',
	'/frontend/account/switch',
	'/frontend/organization/switch',
];

@Injectable()
export class ChangeUrlsInterceptor implements HttpInterceptor {
	constructor(
		@Inject(APP_CONFIG)
		private appConfig: AppConfiguration,
	) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		const currPath = request.url.replace(this.appConfig.apiUrl, '');
		const isCurrPathInReplaceList = REPLACE_LIST.find((url) => currPath.includes(url));
		if (!isCurrPathInReplaceList) {
			return next.handle(request);
		}

		const updatedUrl = request.url.replace('frontend', 'platform');
		const modifiedRequest = request.clone({
			url: updatedUrl,
		});
		return next.handle(modifiedRequest);
	}
}
